import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const GrIntegrationService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getGrRefuseAccountsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/grrefuse/account/search${queryString}`, {
      headers,
    });
  };

  const getGrCitationsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/grparking/citation/search${queryString}`, {
      headers,
    });
  };

  const getGrBlockGrantsAccountBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/grblockgrants/account/search${queryString}`, {
      headers,
    });
  };

  const getGrBlockGrantsBillByAccountId = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/grblockgrants/bills/search${queryString}`, {
      headers,
    });
  };

  const linkCustomerToRefuse = (accountId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/grrefuse/account/${accountId}/link/${customerId}`, undefined, {
      headers,
    });
  };

  const unlinkCustomerFromRefuse = (accountId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/grrefuse/account/${accountId}/unlink/${customerId}`, {
      headers,
    });
  };

  const linkCustomerToCitation = (citationId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/grparking/citations/${citationId}/link/${customerId}`, undefined, {
      headers,
    });
  };

  const unlinkCustomerFromCitation = (citationId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/grparking/citations/${citationId}/unlink/${customerId}`, {
      headers,
    });
  };

  const updateRefuseAccountServiceAddresses = (data = {}) => {
    const { authentication, } = store.getState().auth;
    const { accountId, serviceAddresses = [], } = data;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.put(
      `${BASE_URL}/grrefuse/account/serviceaddresses`,
      {
        accountId,
        serviceAddresses,
      },
      {
        headers,
      }
    );
  };

  service.getGrRefuseAccountsBySearchCriteria = getGrRefuseAccountsBySearchCriteria;
  service.getGrCitationsBySearchCriteria = getGrCitationsBySearchCriteria;
  service.getGrBlockGrantsAccountBySearchCriteria = getGrBlockGrantsAccountBySearchCriteria;
  service.getGrBlockGrantsBillByAccountId = getGrBlockGrantsBillByAccountId;
  service.linkCustomerToRefuse = linkCustomerToRefuse;
  service.unlinkCustomerFromRefuse = unlinkCustomerFromRefuse;
  service.linkCustomerToCitation = linkCustomerToCitation;
  service.unlinkCustomerFromCitation = unlinkCustomerFromCitation;
  service.updateRefuseAccountServiceAddresses = updateRefuseAccountServiceAddresses;

  return service;
})();

export default GrIntegrationService;
